import { ROUTER } from "../../constants/router";
import { Button } from "antd";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

export default function NoPermission() {

    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className="flex h-screen flex-col items-center justify-center gap-4">
            <h1 className="detail-title">{t('noPermission.title')}</h1>
            <p className="form-modal-text text-gray-600">{t('noPermission.goToDashboardDescription')}</p>
            <Button type="primary" onClick={() => navigate(ROUTER.DASHBOARD())}>{t('noPermission.goToDashboardButton')}</Button>
        </div>
    )
}